import React from 'react'
import styles from './Popup.scss'
import { DivOverlay } from 'common/Map/DivOverlay'
import { Icon } from 'common/Icon'
import { base } from 'lib/styleguide/base.scss'
import cx from 'classnames'

export class Popup extends React.PureComponent {
  static defaultProps = {
    offset: [0, -5],
    closeButton: false
  }

  render () {
    const {
      position,
      offset,
      header,
      footer,
      children,
      noPadding,
      noArrow,
      zIndex,
      closeButton,
      onRequestClose,
      autoPan,
      zoomButton
    } = this.props

    return (
      <DivOverlay position={position} offset={offset} autoPan={autoPan} zIndex={zIndex}>
        <div className={cx(styles.container, noArrow && styles.noArrow)}>
          <div className={cx(base, styles.Popup, noPadding && styles.noPadding)}>
            {header && <div className={styles.header}>
              {header}
              {closeButton && <CloseButton onClick={onRequestClose} />}
            </div>}
            <div className={cx(styles.content, noPadding && styles.noPadding)}>
              {/*
                NOTE: elements you pass in as children here will not recieve
                click events. the .content div steals all of those :/
              */}
              {children}
            </div>
            {footer && <div className={styles.footer}>
              {footer}
            </div>}
            {!header && closeButton && <CloseButton onClick={onRequestClose} />}
            {zoomButton && <ZoomButton onClick={zoomButton.onZoomClicked} style={zoomButton.zoomStyle} text={zoomButton.zoomText} />}
          </div>
        </div>
      </DivOverlay>
    )
  }
}

// We need to use native events in Popover content instead of React
// synthetic events, because of the way that GoogleDivOverlay has to
// steamroll events with stopPropagation in order to prevent google
// maps from freaking out.

class ButtonWithNativeClick extends React.PureComponent {
  componentDidMount () {
    this._ref.addEventListener('click', this._onClick)
  }

  componentWillUnmount () {
    this._ref.removeEventListener('click', this._onClick)
  }

  _onClick = (e) => {
    this.props.onClick && this.props.onClick(e)
  }

  render () {
    const { style, children } = this.props

    return <div className={style} ref={r => { this._ref = r }}>
      {children}
    </div>
  }
}

const CloseButton = ({ onClick }) => (
  <ButtonWithNativeClick onClick={onClick} style={styles.close}>
    <Icon i='md-close' />
  </ButtonWithNativeClick>
)

const ZoomButton = ({ onClick, style, text }) => (
  <ButtonWithNativeClick onClick={onClick} style={styles.zoomLink}>
    {text}
  </ButtonWithNativeClick>
)
